import type { ReactNode } from 'react';
import styled from 'styled-components';

import { IconTick } from '@xing-com/icons';
import { ListItem } from '@xing-com/list';
import { spaceXL, spaceS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

interface OfferBenefitItemProps {
  children: ReactNode;
}

export function OfferBenefitItem({
  children,
}: OfferBenefitItemProps): JSX.Element {
  return (
    <OfferBenefitItemWrapper>
      <BenefitItemIcon width={spaceXL} height={spaceXL} />

      <BodyCopy size="medium" sizeConfined="medium" lineHeight="dense" noMargin>
        {children}
      </BodyCopy>
    </OfferBenefitItemWrapper>
  );
}

const OfferBenefitItemWrapper = styled(ListItem)`
  align-items: flex-start;
  padding-left: 0;
  padding-top: ${spaceS};
  padding-bottom: ${spaceS};
`;

const BenefitItemIcon = styled(IconTick)`
  flex-shrink: 0;
`;
